// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5db5be57","879":"8f2ba49a"}[chunkId] + ".chunk.js";
};